// @flow
import { createRequestActions } from 'helpers/redux/createRequestActions'
import * as types from './actionTypes'
import { createRequestActions as request } from '../../actionCreators'

export const organizationSettings = {
  get: createRequestActions({
    request: types.ORGANIZATION_SETTINGS.GET.REQUEST,
    success: types.ORGANIZATION_SETTINGS.GET.SUCCESS,
    fail: types.ORGANIZATION_SETTINGS.GET.FAIL,
  }),
}

export const setPendingGet = pending => ({
  type: types.ORGANIZATION_SETTINGS_SET_PENDING_GET,
  payload: {
    pending,
  },
})

export const fetchOrgPromoPage = request('ORG_PROMO_PAGE/FETCH', organizationId => ({
  request: {
    url: `organizations/${organizationId}/promo-page`,
  },
}))

export const postOrgPromoPage = request('ORG_PROMO_PAGE/POST', data => ({
  request: {
    url: `organizations/${data.organizationId}/promo-page`,
    method: 'POST',
    data,
  },
  success: `Successfully saved promo-page settings`,
}))

export const updateOrgPromoPage = request('ORG_PROMO_PAGE/POST', data => ({
  request: {
    url: `organizations/${data.organizationId}/promo-page`,
    method: 'PUT',
    data,
  },
  success: `Successfully updated promo-page settings`,
}))

export const fetchOrganizationSettingsByDomain = request('ORGANIZATION_SETTINGS/GET_BY_DOMAIN', domain => ({
  request: {
    url: `organizations/by-domain/${domain}`,
  },
}))

export const fetchOrganizationChildren = request('ORGANIZATION_SETTINGS/FETCH_CHILDREN', organizationId => ({
  request: {
    url: `organizations/${organizationId}/children`,
  },
}))

export const postOrganizationChildren = request('ORGANIZATION_SETTINGS/POST_CHILDREN', ({ organizationId, data }) => ({
  request: {
    url: `organizations/${organizationId}/children`,
    method: 'POST',
    data: { organizationIds: data },
  },
}))
